import React from 'react';
import type DataClassificationsSettingsType from '@atlassian/jira-spa-apps-project-settings-data-classifications/src/index.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazyDataClassificationsSettings = lazyForPaint<typeof DataClassificationsSettingsType>(
	() =>
		markAsProductBundleReady(
			import(
				/* webpackChunkName: "async-project-settings-data-classifications", jiraSpaEntry: "async-project-settings-data-classifications" */ '@atlassian/jira-spa-apps-project-settings-data-classifications'
			),
		),
);

const AsyncDataClassificationsSettings = (): React.JSX.Element => (
	<LazyPage
		Page={LazyDataClassificationsSettings}
		pageId="project-settings-data-classifications"
		shouldShowSpinner={false}
	/>
);

export default AsyncDataClassificationsSettings;
